import isNil from 'lodash/isNil';
import { arrayOf, bool, func } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../../generic/Tooltip/get-info-tooltip';
import { campaignShape, productShape } from '../../../prop-types';
import { tapFlashError, tapFlashSuccess } from '../../../utils/flash';
import { addBookingEntry as addBookingEntryAction } from '../../actions/booking-entry-actions';
import { bookingEntryTypes } from '../../constants';
import HELP_TEXTS from '../../help-texts';
import { generateBookingEntriesFromCampaignLines } from '../../utils';

class GenerateCoInvestBookingEntriesButton extends Component {
  state = { loading: false };

  handleOnClick = async () => {
    const { campaign, products, addBookingEntry } = this.props;

    this.setState({ loading: true });
    tapFlashSuccess('Generating co-invest booking entries...')();

    try {
      const bookingEntries = generateBookingEntriesFromCampaignLines(
        campaign,
        products,
        bookingEntryTypes.CO_INVEST.value,
      );

      if (bookingEntries.length) {
        await Promise.all(bookingEntries.map(entry => addBookingEntry(entry)));
        tapFlashSuccess(
          'Successfully generated all co-invest booking entries',
        )();
      } else {
        throw new Error(
          "There aren't any co-invest campaign-lines for this campaign",
        );
      }
    } catch (e) {
      tapFlashError()(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { campaign, disabled } = this.props;
    const { loading } = this.state;

    const isDisabled = loading || isNil(campaign) || disabled;

    return (
      <Button
        className="ml-2"
        disabled={isDisabled}
        onClick={this.handleOnClick}
      >
        Generate Co-Invest Entries{' '}
        {getInfoTooltip(
          HELP_TEXTS,
          'generateCoInvestEntries',
          'actionButtons',
          'top',
        )}
      </Button>
    );
  }
}

GenerateCoInvestBookingEntriesButton.propTypes = {
  campaign: campaignShape,
  products: arrayOf(productShape.isRequired).isRequired,
  addBookingEntry: func.isRequired,
  disabled: bool,
};

GenerateCoInvestBookingEntriesButton.defaultProps = {
  campaign: null,
  disabled: false,
};

export default connect(null, {
  addBookingEntry: addBookingEntryAction,
})(GenerateCoInvestBookingEntriesButton);
